import { useCallback, useState } from 'react';

import { ORDER, SORTING } from './constants';

export type RateRequestSortingType =
  | 'id-alphabetical'
  | 'requested-newest'
  | 'requested-oldest'
  | 'company-name-alphabetical'
  | 'add-yes-first'
  | 'add-no-first'
  | 'remove-yes-first'
  | 'remove-no-first';

export interface RateRequestTableSortingAction {
  type?: string | undefined;
}

export type RateRequestTableOnAction = (
  action?: RateRequestTableSortingAction,
) => void;

export interface RateRequestSortingHook {
  sorting: string;
  order: string;
  onAction: RateRequestTableOnAction;
}

export default function useRateRequestTableSorting(): RateRequestSortingHook {
  const [sorting, setSorting] = useState(SORTING.DATE_REQUESTED);
  const [order, setOrder] = useState(ORDER.NORMAL);

  const onAction = useCallback(
    (action: RateRequestTableSortingAction = {}) => {
      const type = action?.type as RateRequestSortingType;
      console.log({ type });
      if (type === 'id-alphabetical') {
        if (sorting !== SORTING.ID) {
          setSorting(SORTING.ID);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }
      if (type === 'company-name-alphabetical') {
        if (sorting !== SORTING.COMPANY_NAME) {
          setSorting(SORTING.COMPANY_NAME);
          setOrder(ORDER.NORMAL);
          return;
        }
        if (order === ORDER.NORMAL) {
          setOrder(ORDER.INVERSE);
          return;
        }
        setOrder(ORDER.NORMAL);
        return;
      }
      if (type === 'requested-newest') {
        if (sorting !== SORTING.DATE_REQUESTED) setSorting(SORTING.ID);
        setOrder(ORDER.NORMAL);
        return;
      }
      if (type === 'requested-oldest') {
        if (sorting !== SORTING.DATE_REQUESTED) setSorting(SORTING.ID);
        setOrder(ORDER.INVERSE);
        return;
      }
      if (type === 'add-yes-first') {
        if (sorting !== SORTING.RATE_ADD) setSorting(SORTING.RATE_ADD);
        setOrder(ORDER.NORMAL);
        return;
      }
      if (type === 'add-no-first') {
        if (sorting !== SORTING.RATE_ADD) setSorting(SORTING.RATE_ADD);
        setOrder(ORDER.INVERSE);
        return;
      }
      if (type === 'remove-yes-first') {
        if (sorting !== SORTING.RATE_REMOVE) setSorting(SORTING.RATE_REMOVE);
        setOrder(ORDER.NORMAL);
        return;
      }
      if (type === 'remove-no-first') {
        if (sorting !== SORTING.RATE_REMOVE) setSorting(SORTING.RATE_REMOVE);
        setOrder(ORDER.INVERSE);
        return;
      }

      setSorting(SORTING.DATE_REQUESTED);
      setOrder(ORDER.NORMAL);
      return;
    },
    [order, sorting],
  );

  return {
    sorting,
    order,
    onAction,
  };
}
